import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";

import { Router, Route } from "@angular/router";
import { LoaderService } from "./../../../core/services/loader.service";
import { AuthService } from 'dlv-ng-auth';
import {
  FormBuilder,
  FormGroup,
  Validators
} from "@angular/forms";
import { SettingsConstant } from "./../../../shared/constants/settings.constants";
import { NgxPermissionsService } from "ngx-permissions";
import { ToastrService } from "ngx-toastr";
import { LoginService } from './../../services/login.service';
import { GenericUtils } from './../../../shared/utilities/generic-utils';
import { environment } from './../../../../environments/environment';
import { interval } from "rxjs";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers: [ LoginService ]
})
export class LoginComponent implements OnInit, OnDestroy {
  public isNoScope = false;
  profile: any;
  private unsubscribe: Subject<void> = new Subject();
  loginForm: FormGroup;
  loginViaDelhivery = false;

  isPasswordExpired = false;
  redirectTimer = 5;
  toggle = false;

  constructor(
    private loader: LoaderService,
    private router: Router,
    public auth: AuthService,
    private fb: FormBuilder,
    private loginService: LoginService,
    private utils: GenericUtils,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    // 666 Is Authenticated can be shifted to new login as well - the below piece of code has no usefulness
    // if(this.loginService.isAuthenticated()){
    //   this.loginService.logOut();
    // }
    if (this.auth.isAuthenticated()) {
      this.loader.start();
      return this.router.navigate(["/overall-status"]); // Is this correct? - doesn't it need to be redirected according to user permission?
    }else{
      this.loginService.logOut();
    }
    // 666 ends
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(2)]],
      password: ['', [Validators.required, Validators.minLength(2)]]
    });

  }

  login() {
    if(!this.loginForm.controls.username.value || !this.loginForm.controls.password.value) {
      this.toastr.error("Please enter username and password to login!");
      return;
    }
    const body = {
      username: this.loginForm.controls.username.value,
      password: this.loginForm.controls.password.value
    };
    this.loader.start();
    this.loginService.login(body).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      if (response && response['jwt']) {
        this.utils.storeCookie(`${environment.accessToken}` , response['jwt'], '', this.utils.getSubDomainName());
        this.toastr.success('Succesfully logged in!');
        return this.router.navigate(["/overall-status"]);
      }
    }, errorMsg => {
      this.loader.stop();
      if (errorMsg && errorMsg['error']) {
        if(typeof errorMsg['error'] === 'string') {
          this.toastr.error(errorMsg['error']);
        }else{
          if(errorMsg['error'].error_code && errorMsg['error'].error_code == 'UMS001'){
            this.isPasswordExpired = true;
            this.passwordExpired();
          }else{
            this.toastr.error("Invalid username or password!");
          }
        }
      }
    });
  }

  passwordExpired() {
    var x = setInterval(() => {

      if(this.redirectTimer == 0) {
        clearInterval(x);
        this.goToPage();
        return;
      }
      
      this.redirectTimer = this.redirectTimer - 1;

    }, 1000);
  }

  goToPage() {
    this.isPasswordExpired = false;
    this.redirectTimer = 5;
    let data = {
      redirect_url: `${environment.AUTH_REDIRECT_URI}`, 
      username: this.loginForm.controls.username.value
    }
    window.location.replace(
      `${environment.PASSWORD_EXPIRE}${btoa(JSON.stringify(data))}`
    );
  }

  forgotPassword() {
    if(!this.loginForm.controls.username.value){
      this.toastr.error("Please enter username!");
      return;
    }
    const body = {
      user: this.loginForm.controls.username.value,
      redirect_url: environment.AUTH_REDIRECT_URI
    };
    this.loader.start();
    this.loginService.forgotPassword(body).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      this.loader.stop();
      if (response && response['msg']) {
        this.toastr.success(response['msg']);
      }
    }, errorMsg => {
      this.loader.stop();
      if (errorMsg && errorMsg['error']) {
        this.toastr.error(errorMsg['error']);
      }
    });
  }

  // 666 redundant Function
  // checkScope = scopes => {
  //   const scope = scopes ? scopes.split(' ') : [];
  //   let permissions = this.auth0Service.removedUnusedScope(scope, ['openid', 'profile', 'email']);

  //   if(scopes && permissions > 0) {
  //     this.isNoScope = false;
  //     this.ngxService.loadPermissions(scopes);
  //   }else{
  //     this.router.navigate(["/sync-permissions"], { replaceUrl: true });
  //   }
  // };

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
